<script>
import ObjectsComponent from "./desktop/ObjectsComponent.vue";
import PriceComponent from "./PriceComponent.vue";
import ReportTypeComponent from "./ReportTypeComponent.vue";
import StartProcessButtonComponent from "./StartProcessButtonComponent.vue";

export default {
  name: "DesktopComponent",
  components: {
    ObjectsComponent,
    PriceComponent,
    ReportTypeComponent,
    StartProcessButtonComponent
  },
  props: {
    objects: {
      type: Array,
      required: true
    },
    reportType: {
      type: Number,
      required: true
    },
    paperReportPrice: {
      type: Number,
      required: true
    },
    deleteCartItemHandler: {
      type: Function,
      required: true
    },
    changeReportTypeHandler: {
      type: Function,
      required: true
    },
    price: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div class="desktop">
    <div class="row">
      <div class="col-sm-12">
        <h1>Нотариат</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="content">
          <objects-component
            :objects="objects"
            :report-type="reportType"
            :paper-report-price="paperReportPrice"
            :delete-cart-item-handler="deleteCartItemHandler"
          />
          <price-component :price="price" />
          <report-type-component
            :report-type="reportType"
            :change-report-type-handler="changeReportTypeHandler"
          />
        </div>
      </div>
    </div>
    <start-process-button-component />
  </div>
</template>

<style scoped>

</style>
